export default __webpack_public_path__ + "static/media/box2_step1.ff88556b.png";